import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb",
  "use": "fb-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"fb\"><path d=\"M12.008 6.992v4.189H9.047l.004 6.332 3.549-.048v13.964h5.329V17.465h4.145l.592-6.284h-4.737V7.69c0-.995.196-1.396 1.184-1.396h3.553L22.604.306S21.155 0 18.889 0c-4.965 0-6.882 3.519-6.882 6.992z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol